var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('v-avatar',{attrs:{"size":"20","small":_vm.small,"color":"channel","title":_vm.value}},[_c('v-icon',{attrs:{"color":"black","small":_vm.small}},[_vm._v("mdi-transit-connection-variant ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }